import { FC } from 'react';
import AlfredTableTemplate from 'components/template/AlfredTableTemplate';
import { PremiumUserCustomModel, useTabBillableUserList } from './resources/useTabUserList';
import Paper from '../../../atoms/Paper';


const TabBillableUserList: FC = () => {
  const {
    columns,
    dataList,
    filters,
    totalPages,
    pageSize,
    currentPage,
    onChangePage,
    onRowClick,
    onFilter,
    isLoading,
    isLoadingFilters,
  } = useTabBillableUserList();

  return (
    <Paper>
      <AlfredTableTemplate<PremiumUserCustomModel>
        columns={columns}
        data={dataList}
        totalPages={totalPages}
        pageSize={pageSize}
        pageCurrent={currentPage}
        onPagination={onChangePage}
        onRowClick={onRowClick}
        isCharging={isLoading}
        isLoadingFilters={isLoadingFilters}
        filters={filters}
        onFilter={onFilter}
      />
    </Paper>
  );
};

export default TabBillableUserList;
